import { ParentState } from "@checkout/index";
import { ActionTypes } from "./actions";
import { ServiceTypes } from "./services";

// can't import from stateMachine due to initialization
const activitiesMachineId = "rbc-activities-checkout";

const nextStep = `#${activitiesMachineId}.${ParentState.contactAndTravelerInformation}`;

enum InitializeStates {
  fetchAll = "fetchAll",
  error = "error",
  complete = "complete",
}

// TODO(Nate): Add in check if we have shop info, if not send back to navigate(-1) if it's a /shop, otherwise ctx[ParentState.lodgingShop]?.availabilityLink
export const initializeState = {
  initial: InitializeStates.fetchAll,
  states: {
    [InitializeStates.fetchAll]: {
      type: "parallel" as const,
      states: {
        // TODO(Nate): Do activities have offers?
        // [OfferPaymentState]: initializeOfferPaymentState,
        [ParentState.travelerInformation]: {
          initial: "fetch",
          states: {
            fetch: {
              invoke: {
                src: ServiceTypes.fetchTravelersService,
                onDone: {
                  target: "success",
                  actions: [
                    ActionTypes.setUserPassengers,
                    ActionTypes.setTravelers,
                  ],
                },
                onError: {
                  target: "error",
                  actions: ActionTypes.setTravelersError,
                },
              },
            },
            success: { type: "final" },
            error: { type: "final" }, //TODO: remove final state here after testing
          },
        },
      },
      // When all parallel states reach final state, onDone executes
      onDone: InitializeStates.complete,
    },
    [InitializeStates.error]: {},
    [InitializeStates.complete]: {
      initial: "route",
      states: {
        route: {
          always: [
            {
              target: nextStep,
            },
          ],
        },
      },
    },
  },
};
